// Each side keeps its side of the conversation: your team on the right, the other team on the left.
export const isOwnSideMessage = (accountId: number, ownerAccountIds: number[], amIBuildingOwner: boolean) =>
  ownerAccountIds.includes(accountId) === amIBuildingOwner;
